//动态列自定义表格
export default {
  data() {
    return {
      columnData: [],
      tableDataSet: [],
      tableVisible: false,
      pagingColumnData: [],
      isShowTure: [],
      userColumnsData: [],
      columnJurisdiction: false,
      tableReload: true,
    }
  },
  computed: {
    reportName() {
      let data = ''
      if (this.activeTable == 0) {
        data = 'newOverviewOfSalesProducts'
      } else if (this.activeTable == 1) {
        data = 'newProPriceSegmentReport'
      } else if (this.activeTable == 2) {
        data = 'newProHundredSaleNumReport'
      } else if (this.activeTable == 3) {
        data = 'newProSaleNumReport'
      } else if (this.activeTable == 4) {
        data = 'salesPerformanceOfNewProducts'
      }
      return data
    },
    activeType() {
      return this.activeTable == 0 || this.activeTable == 4
    }
  },
  mounted() {
    let buttonJurisdiction = JSON.parse(localStorage.getItem("permitList")); //列展示权限获取
    let Jurisdiction =
      "ec-pc-new$analysisDashboard$productAnalysis$yearBehavior$prices";
    this.columnJurisdiction = buttonJurisdiction.includes(Jurisdiction);
    this.columns()
  },
  methods: {
    columns() {
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then(res => {
        if (this.activeType) {
          this.isShowTure = res.data.userColumns.length ? res.data.userColumns.filter(v => v.isShow).map(v => v.displayName) : []
          this.userColumnsData = res.data.userColumns.length ? res.data.userColumns : []
        } else {
          this.columnsData = res.data
        }
        if (this.activeType) {
          this.dynamicCustomColumn()
        }else {
          this.customColumn(this.columnsData)
        }
      });
    },
    customForm() {
      this.tableVisible = false;
      this.columns()
    },
    confirm() {
      let data = []
      this.tableDataSet.forEach(v => {
        let freezeFlag = v.freezeLeft || v.freezeRight ? true : false
        data.push({
          displayName: v.displayName,
          columnName: v.columnName,
          displayWidth: parseInt(v.displayWidth),
          reportName: this.reportName,
          freezeFlag: freezeFlag,
          freezeType: freezeFlag && v.freezeLeft ? 'left' : freezeFlag && v.freezeRight ? 'right' : '',
          isShow: v.isShow
        })
      })
      this.$q.common.mergeColumns({ data: data }).then(res => {
        if (res.success) {
          this.$message.success('自定义配置成功')
          this.tableReload = false
          this.$nextTick(_ => {
            this.tableReload = true;
          });
          this.columns()
        } else {
          this.$message.error('自定义配置失败')
        }
        this.customForm()
      });
    },
    dynamicCustomColumn(data) {
      this.columnData = []
      var data = [];
      var tableDataSet = []
      var columnData = this.userColumnsData.map(v => v.displayName)
      this.pagingColumnData.forEach((v) => {
        let index = columnData.indexOf(v.titleName)
        if (this.userColumnsData.length) { //用户配置返回
          if (columnData.indexOf(v.titleName) != -1) { //包含用户之前配置的列
            tableDataSet.push({
              displayName: this.userColumnsData[index].displayName,
              displayWidth: this.userColumnsData[index].displayWidthNum,
              freezeLeft: this.userColumnsData[index].freezeType == 'left' ? true : false,
              freezeRight: this.userColumnsData[index].freezeType == 'right' ? true : false,
              isShow: this.userColumnsData[index].isShow,
              columnName: this.userColumnsData[index].columnName
            })
            if (this.isShowTure.indexOf(v.titleName) == -1) {
              data.push({
                label: this.userColumnsData[index].displayName,
                prop: this.userColumnsData[index].columnName,
                width: this.userColumnsData[index].displayWidth,
                sortable: v.sortable == "1" ? 'custom' : false,
                span: false,
                fixed: this.userColumnsData[index].freezeType,
              });
            }
          } else { //不包含使用分页返回的列
            tableDataSet.push({
              displayName: v.titleName,
              displayWidth: '100',
              freezeLeft: v.freezeType == 'left' ? true : false,
              freezeRight: v.freezeType == 'right' ? true : false,
              isShow: v.isShow,
              columnName: v.propertyName
            })
            if (this.isShowTure.indexOf(v.titleName) == -1) {
              data.push({
                label: v.titleName,
                prop: v.propertyName,
                width: "100px",
                sortable: v.sortable == '1' ? "custom" : false,
                span: false,
                fixed: v.fixed == "1" ? "left" : false,
              });
            }
          }
        } else {//用户为配置使用分页默认配置
          tableDataSet.push({
            displayName: v.titleName,
            displayWidth: '100',
            freezeLeft: v.freezeType == 'left' ? true : false,
            freezeRight: v.freezeType == 'right' ? true : false,
            isShow: v.isShow,
            columnName: v.propertyName
          })
          data.push({
            label: v.titleName,
            prop: v.propertyName,
            width: "150px",
            sortable: v.sortable == '1' ? "custom" : false,
            span: false,
            fixed: v.fixed == "1" ? "left" : false,
          });
        }
      });
      if(this.columnJurisdiction) {
        this.columnData = data
        this.tableDataSet = tableDataSet
      }else {
        this.columnData = data.filter(v=>v.label != '销售额')
        this.tableDataSet = tableDataSet.filter(v=>v.displayName != '销售额')
      }
    },
    customColumn(data) {
      var tableSetData = []
      if (data.userColumns.length) {
        tableSetData = data.userColumns
        data = data.userColumns.filter(v => !v.isShow)
      } else {
        tableSetData = data.sysColumns
        data = data.sysColumns
      }
      let columnData = []
      let list = []
      data.forEach(v => {
        columnData.push({
          label: v.displayName,
          prop: v.columnName,
          width: v.displayWidth,
          sortable: v.sortable == '1' ? "custom" : false,
          span: false,
          fixed: v.freezeType,
        })
      })
      tableSetData.forEach(v => {
        list.push({
          displayName: v.displayName,
          displayWidth: v.displayWidthNum,
          freezeLeft: v.freezeType == 'left' ? true : false,
          freezeRight: v.freezeType == 'right' ? true : false,
          isShow: v.isShow,
          columnName: v.columnName
        })
      });
      //销售额字段权限过滤
      if(this.columnJurisdiction) {
        this.tableDataSet = list
        this.columnData = columnData
      }else {
        this.columnData = columnData.filter(v=>v.label != '销售额')
        this.tableDataSet = list.filter(v=>v.displayName != '销售额')
      }
    },
  }
}